import { Combination } from "../types";

// Function to create a 2D array of numbers
export const create2DArray = (rows: number, columns: number, minValue = 0, maxValue = 0): number[][] => {
    const array: number[][] = [];
    for (let i = 0; i < rows; i++) {
        const row: number[] = [];
        for (let j = 0; j < columns; j++) {
            // You can populate the array with any values you like. For this example, I'm using random numbers between 1 and 100.
            row.push(Math.floor(Math.random() * maxValue) + minValue);
        }
        array.push(row);
    }
    return array;
};

export const isNullOrUndefined = (variable: any): Boolean => {
    return variable === null || variable === undefined ? true : false; // Returns true if variable is null or undefined
};

export const calculatePallets = (combination: Combination) => {
    const { quantity, palletCapacity } = combination;
    return Math.ceil(quantity / palletCapacity);
};

export const calculateFactor = (combination: Combination) => {
    const {
        forecast,
        quarterlyAvgForecast,
        soh,
        quantity,
        arrival,
        docMax,
        palletHoldingCost,
        palletCapacity,
        caseMargin,
    } = combination;
    // get weekly forecast
    const weeklyForecast = forecast / 4;
    // calculate soh and doc per week of the month (4 weeks)
    const weeks = [
        {
            soh: soh,
            doc: (soh / forecast) * 30,
            insufficientStock: soh < weeklyForecast ? weeklyForecast - soh : 0,
        },
    ];

    // loop through the remaining 3 weeks
    for (let i = 1; i < 4; i++) {
        // calculate soh for the week (prev soh + prev arrival - weekly forecast)
        let soh = weeks[i - 1].soh + (Number(arrival) === i ? quantity : 0) - weeklyForecast;
        // if soh is negative, set it to 0
        if (soh < 0) soh = 0;
        let insufficientStock = soh < weeklyForecast ? weeklyForecast - soh : 0;
        // calculate doc for the week
        let doc = (soh / forecast) * 30;
        // set soh and doc for the week
        weeks.push({ soh, doc, insufficientStock });
    }

    // holding cost
    let holdingCost = 0;
    const closingSoh = weeks[weeks.length - 1].soh + (Number(arrival) === weeks.length ? quantity : 0) - weeklyForecast;
    console.log("closingSoh", closingSoh);
    const closingDoc = (closingSoh / quarterlyAvgForecast) * 30;
    console.log("closingDoc", closingDoc);
    if (closingDoc > docMax) {
        const extraDays = closingDoc - docMax;
        console.log("extraDays", extraDays);
        const extraQuantity = (extraDays / 30) * quarterlyAvgForecast;
        console.log("extraQuantity", extraQuantity);
        console.log("pallet capacity", palletCapacity);

        console.log("number of pallets", Math.ceil(extraQuantity / palletCapacity));

        holdingCost = Math.ceil(extraQuantity / palletCapacity) * palletHoldingCost;
    }
    // calculate missed margin
    const missedMargin = weeks.reduce((prev, curr) => prev + curr.insufficientStock * caseMargin, 0);
    // calculate gross margin
    const grossMargin = weeks.reduce((prev, curr) => prev + Math.min(curr.soh, weeklyForecast) * caseMargin, 0);
    //calculate net margin
    const { inboundCost, outboundCost } = combination;
    console.log("weeks", weeks);

    console.log("grossMargin", grossMargin);
    console.log("missedMargin", missedMargin);
    console.log("inboundCost", inboundCost);
    console.log("outboundCost", outboundCost);
    console.log("holdingCost", holdingCost);

    const netMargin = grossMargin - missedMargin - holdingCost - inboundCost - outboundCost;

    return netMargin / 4;
};
